/**
 * Computes image dimensions.
 *
 * @param   {File}    file  Image file.
 * @returns {object}        Image dimensions.
 */
export const getImageDimensions = async (file) => {
    return new Promise(resolve => {
        const url = URL.createObjectURL(file);
        const image = new Image();

        /**
         * Fires after loading image.
         */
        const callback = () => {
            resolve({
                width: image.width,
                height: image.height,
            });

            URL.revokeObjectURL(url);
            image.removeEventListener('load', callback);
        };

        image.addEventListener('load', callback);
        image.src = url;
    });
};

/**
 * Loads file as data URL.
 *
 * @param   {File}    file File instance.
 * @returns {Promise}      Promise instance.
 */
export const toBase64 = async (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});
